import { ResourceOptions } from 'react-admin';
import { FaWallet } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.blindBoxWithdrawals;
export const icon = FaWallet;
export const options: ResourceOptions = {
  label: 'module.blindBox.withdrawRecords',
};
